import { FieldType } from '../../types/custom-worksheet-v2';
import { CalendarIcon, CurrencyDollarIcon, HashtagIcon, ReceiptPercentIcon, ScaleIcon } from '@heroicons/react/20/solid';

type FieldIconProps = {
    type: FieldType;
};

function FieldIcon({ type }: FieldIconProps): JSX.Element {
    switch (type) {
        case FieldType.ACCOUNTING:
            return <ScaleIcon />;
        case FieldType.DATE:
            return <CalendarIcon />;
        case FieldType.MONEY:
            return <CurrencyDollarIcon />;
        case FieldType.NUMBER:
            return <HashtagIcon />;
        case FieldType.PERCENT:
            return <ReceiptPercentIcon />;
        case FieldType.TEXT:
            return <p className="font-medium italic leading-none">T</p>;
        default:
            return <></>;
    }
}

export default FieldIcon;
